
import React, { useCallback, useEffect, useState } from "react";
import "../../App.css";
import "../../profile.css";
import { ArrowLeft, Calendar, Clock } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import service from "../../services/service";
import endpoints from "../../services/endpoints";

const EditGroup = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [teamName, setTeamName] = useState("");
  const [challengeName, setChallengeName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [teamId, setTeamId] = useState(null);
  const [challengeId, setChallengeId] = useState(null);

  const fetchTeamdetail = useCallback(async () => {
    try {
      const res = await service.get(
        endpoints.teammanagment.teamdetail(id),
        {},
        { skipToast: true },
      );
      const data = res.data.data;

      setTeamId(data.id);
      setChallengeId(data.challengeId);
      setTeamName(data.teamName);
      setChallengeName(data.challengeName);

      if (data.challenge_startdate) {
        setStartDate(data.challenge_startdate.split("T")[0]);
      }
      if (data.challenge_starttime) {
        const date = new Date(data.challenge_starttime);
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        setStartTime(`${hours}:${minutes}`);
      }
    } catch (error) {
      console.log(error);
    }
  }, [id]);

  useEffect(() => {
    fetchTeamdetail();
  }, [fetchTeamdetail]);

  const handleUpdate = async () => {
    if (!startDate || !startTime) return;
    const payload = {
      teamName,
      startDate,
      startTime,
    };

    try {
      setLoading(true);
      const res = await service.patch(
        endpoints.teammanagment.editgroup(id),
        payload,
      );
      console.log(res.data);
      navigate(-1);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="group-page">
      <div className="group-title-page">
        <ArrowLeft className="cursor" onClick={() => navigate(-1)} />
        <h2>Edit Group</h2>
      </div>

      <div className="group-form">
        <div className="form-group">
          <label>Group Name</label>
          <input
            type="text"
            value={teamName}
            onChange={(e) => setTeamName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Select Challenge</label>
          <div className="input-icon">
            <input
              type="text"
              value={challengeName}
              disabled
              style={{ opacity: 0.6, cursor: "not-allowed" }}
            />
          </div>
        </div>
        <div className="form-group">
          <label>Date</label>
          <div
            className="input-icon"
            onClick={() => document.getElementById("dateInput").showPicker()}
          >
            <input
              id="dateInput"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{ cursor: "pointer" }}
            />
            <Calendar size={18} style={{ cursor: "pointer" }} />
          </div>
        </div>
        <div className="form-group">
          <label>Time</label>
          <div
            className="input-icon"
            onClick={() => document.getElementById("timeInput").showPicker()}
          >
            <input
              id="timeInput"
              type="time"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              style={{ cursor: "pointer" }}
            />
            <Clock size={18} style={{ cursor: "pointer" }} />
          </div>
        </div>

        <button
          className="red-btn form-btn"
          onClick={handleUpdate}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update"}
        </button>
      </div>
    </div>
  );
};

export default EditGroup;